import { render } from "./SidebarEvents.vue?vue&type=template&id=5cef596a&ts=true"
import script from "./SidebarEvents.vue?vue&type=script&lang=ts"
export * from "./SidebarEvents.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Episcenter\\smartCity\\smartcity\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__